import React, { useMemo, useRef, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { ColDef, ColumnState } from "ag-grid-community";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { GridContextWrapper } from "src/components/common/gridWrapper/GridContextWrapper";
import Grid_Select from "src/components/common/gridWrapper/Grid_Select";
import { PDA1121_R01Dto } from "./PDA1121_R01Dto";
import { aggridHeaderClass, pdaCellStyle } from "src/components/common/common";

interface Props {
  orderList: PDA1121_R01Dto[];
  onSelectOrder: (order: PDA1121_R01Dto) => void;
}
type Row = PDA1121_R01Dto & { inserted?: boolean };

const PDA1121_R01Table = ({ orderList, onSelectOrder }: Props) => {
  const gridRef = useRef<AgGridReact<Row>>(null);
  const gridWrapperRef = useRef<HTMLDivElement>(null);
  const [, setColumnState] = useState<ColumnState[] | null>(null);
  const [, setHoveredRowIndex] = useState<number | null>(null);

  const paddedGridData = useMemo(() => orderList.map((o) => ({ ...o, inserted: false })), [orderList]);

  const columnDefs: ColDef<Row>[] = useMemo(
    () => [
      {
        headerName: "일자",
        field: "workDt",
        valueGetter: (p) => p.data?.workDt || "-",
        cellStyle: { textAlign: "center", ...pdaCellStyle },
        headerClass: aggridHeaderClass,
        flex: 0.8,
        minWidth: 80,
      },
      {
        headerName: "품명",
        field: "itemNm",
        valueGetter: (p) => p.data?.itemNm || "-",
        cellStyle: { textAlign: "left", ...pdaCellStyle },
        headerClass: aggridHeaderClass,
        flex: 1.5,
        minWidth: 80,
      },
      {
        headerName: "규격",
        field: "itemSpec",
        valueGetter: (p) => p.data?.itemSpec || "-",
        cellStyle: { textAlign: "left", ...pdaCellStyle },
        headerClass: aggridHeaderClass,
        flex: 1.2,
        minWidth: 80,
      },
      {
        headerName: "지시량",
        field: "orderQty",
        valueGetter: (p) => (p.data?.orderQty != null ? p.data.orderQty.toLocaleString() : "-"),
        cellStyle: { textAlign: "right", justifyContent: "flex-end", ...pdaCellStyle },
        headerClass: aggridHeaderClass,
        flex: 0.8,
        minWidth: 80,
      },
    ],
    []
  );

  return (
    <div className="flex-1 p-3 pt-2 flex w-full h-full flex-col overflow-hidden">
      <GridContextWrapper
        gridRef={gridRef}
        gridWrapperRef={gridWrapperRef}
        paddedGridData={paddedGridData}
        initSelected={() => {}}
        baseColumnDefs={columnDefs}
        setColumnState={setColumnState}
        localStorageKey="PDA1121_R01_ColumnState"
        enableDataHistory={false}
      >
        <div className="flex-1 w-full h-full min-h-0">
          <Grid_Select<Row>
            ref={gridRef}
            rowData={paddedGridData}
            columnDefs={columnDefs}
            rowSelection="single"
            onRowClicked={(e) => e.data && onSelectOrder(e.data)}
            setHoveredRowIndex={setHoveredRowIndex}
            columnStateKey="PDA1121_R01_ColumnState"
            setColumnState={setColumnState}
          />
        </div>
      </GridContextWrapper>
    </div>
  );
};

export default PDA1121_R01Table;
